import React, { useRef, useEffect, useCallback } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import '../closeportal.scss';
import { quillFormFieldModules, quillFormFieldFormats, URL_PATTERN } from '../constants';

function RichTextEditor({ value, onChange, placeholder = "Enter text content" }) {
    const quillRef = useRef(null);

    const handlePaste = useCallback((clipboardEvent) => {
        const editor = quillRef.current?.getEditor();
        if (!editor) return;

        const range = editor.getSelection();
        if (!range) return;

        const pastedText = clipboardEvent.clipboardData.getData('text/plain').trim();
        if (!URL_PATTERN.test(pastedText)) return;

        clipboardEvent.stopImmediatePropagation();
        clipboardEvent.preventDefault();

        if (range.length > 0) {
            // Text is selected — hyperlink the selected text
            editor.formatText(range.index, range.length, 'link', pastedText);
        } else {
            // No selection — insert the URL as a clickable link
            editor.insertText(range.index, pastedText, 'link', pastedText);
        }
    }, []);

    useEffect(() => {
        const editor = quillRef.current?.getEditor();
        if (editor) {
            // Use capture phase to intercept before Quill's clipboard module
            editor.root.addEventListener('paste', handlePaste, true);
            return () => editor.root.removeEventListener('paste', handlePaste, true);
        }
    }, [handlePaste]);

    return (
        <div className="quill-wrapper">
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                modules={quillFormFieldModules}
                formats={quillFormFieldFormats}
            />
        </div>
    );
}

export default RichTextEditor;
